const data = [
  
  {
    id: "rec1Ntk7siEEW9ha1",
    name: "Apple iPhone 13 Pro Max",
    price: 129900,
    image: "https://i.ibb.co/thf0SL3/61rrisp8qi-L-SL1500.png",
    company: "Only",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    category: "Casual",
    shipping: true,
    amount: 1,
    stock: 2,
  },
  {
    id: "recNZ0koOqEmilmoz",
    name: "Samsung Galaxy A32",
    price: 23499,
    image: "https://i.ibb.co/D5nGKrs/81-TTzz-RL-SL1500.png",
    company: "Zebronics ZEB-KM2100 Multimedia USB Keyboard",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    category: "Office",
    shipping: true,
    amount: 1,
    stock: 3,
  },
  {
    id: "recrfxv3EwpvJwvjq",
    name: "Redmi Note 11T 5G",
    price: 19999,
    image: "https://i.ibb.co/TMzG7fJ/81-L7-WGg-Dk-L-SL1500.png",
    company: "Only",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    category: "Office",
    shipping: true,
    amount: 1,
    stock: 4,
  },
  // {
  //   id: "recZkNf2kwmdBcqd0",
  //   name: "Green Top",
  //   price: 25,
  //   image: "https://i.ibb.co/7CQVJNm/blue-tank.png",
  //   company: "Levis",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit.",
  //   category: "Casual",
  //   shipping: true,
  //   amount: 1,
  //   stock: 4,
  // },
  {
    id: "recEHmzvupvT8ZONH",
    name: "STRIFF Laptop Stand",
    price: 499,
    image: "https://i.ibb.co/hfMxDRZ/71-Zf9u-Up-GL-SL1500.png",
    company: "Vero Moda",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    category: "Office",
    shipping: true,
    amount: 1,
    stock: 6,
  },
  {
    id: "rec5NBwZ5zCD9nfF0",
    name: "LIRAMARK Webcam Cover Slide",
    price: 211,
    image: "https://i.ibb.co/WH4LVQ3/61-E8-Sq-U4-J-L-SL1435.png",
    company: "Only",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    category: "Casual",
    amount: 1,
    stock: 4,
  },
  {
    id: "recd1jIVIEChmiwhe",
    name: "Maxelon™ Laptop Battery",
    price: 500,
    image: "https://i.ibb.co/hWckM5h/51-Vt-Ko5-DHOL-SL1200.png",
    company: "Vero Moda",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    category: "Office",
    shipping: true,
    amount: 1,
    stock: 4,
  },
  {
    id: "recoM2MyHJGHLVi5l",
    name: "ASUS VivoBook Flip 14",
    price: 41990,
    image: "https://i.ibb.co/5cBV1nR/717i-Uvk-Xm9-L-SL1500.jpg",
    company: "Only",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    category: "Office",
    shipping: true,
    amount: 1,
    stock: 4,
  },
  {
    id: "recotY5Nh00DQFdkm",
    name: "Dell Inspiron 5518",
    price: 69736,
    image: "https://i.ibb.co/Lx5w9mq/71-FH2-Hi-GKx-S-SL1280.png",
    company: "Only",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    category: "Casual",
    shipping: true,
    amount: 1,
    stock: 4,
  },

  {
    id: "recoW8ecgjtKx2Sj2",
    name: "Lenovo IdeaPad Slim 5i",
    price: 74999,
    image: "https://i.ibb.co/DPJ0JGK/61-WNxd-Ae-Ao-L-SL1000.png",
    company: "Vero Moda",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis, provident. Itaque totam neque, nesciunt consequatur error quasi ipsam accusamus facere!Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    category: "Casual",
    amount: 1,
    stock: 5,
  },
];
export default data;
